module.exports = __webpack_public_path__ + "img/211.6b4908d8.png";